import moment from 'moment'

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

interface MonthYear {
  timestamp: moment.Moment
  month: string
  year: string
}

/**
 * Create a `MonthYear` object given a moment object
 */
export function getMonthYearObj (from?: moment.Moment): MonthYear {
  const m = from || moment(from)
  return {
    timestamp: m,
    month: MONTHS[m.month()],
    year: `${m.year()}`
  }
}

/**
 * Return a list of previous `MonthYear`s
 */
export function getPreviousMonths (delta: number, count = 0, months: MonthYear[] = []): MonthYear[] {
  if (count <= delta - 1) {
    months.push(getMonthYearObj(moment().subtract(count, 'months')))
    return getPreviousMonths(delta, count + 1, months)
  }

  return months
}

const todayUnix = moment().endOf('day').unix()
const yesterdayUnix = moment().subtract(1, 'day').endOf('day').unix()

export function todayYesterday (m: moment.Moment, today = todayUnix, yesterday = yesterdayUnix) {
  const date = moment(m).endOf('day').unix()
  if (date === today) {
    return 'Today'
  }

  if (date === yesterday) {
    return 'Yesterday'
  }

  return m.fromNow()
}
